// Vegas — ported from GolfGamesScorecard's calcVegas (utils/scoring.ts). Each
// team forms a two-digit number (low ball first); a birdie flips the opponent's
// number; the lower number banks the difference. (pars is passed in rather than
// read off the player object, but the logic is identical.)
export function calcVegas(team1, team2, pars = []) {
  let t1Total = 0
  let t2Total = 0
  const holeResults = Array.from({ length: 18 }, (_, hole) => {
    const t1Scores = team1.map((p) => p.scores[hole] ?? 9).sort((a, b) => a - b)
    const t2Scores = team2.map((p) => p.scores[hole] ?? 9).sort((a, b) => a - b)
    let t1Num = parseInt(`${t1Scores[0]}${t1Scores[1]}`)
    let t2Num = parseInt(`${t2Scores[0]}${t2Scores[1]}`)
    const t1Birdie = team1.some((p) => (p.scores[hole] ?? 99) < (pars[hole] ?? 4))
    const t2Birdie = team2.some((p) => (p.scores[hole] ?? 99) < (pars[hole] ?? 4))
    if (t1Birdie) t2Num = parseInt(String(t2Num).split('').reverse().join(''))
    if (t2Birdie) t1Num = parseInt(String(t1Num).split('').reverse().join(''))
    const diff = Math.abs(t1Num - t2Num)
    if (t1Num < t2Num) t1Total += diff
    else if (t2Num < t1Num) t2Total += diff
    return { t1Num, t2Num, diff }
  })
  return { holeResults, t1Total, t2Total, winner: t1Total > t2Total ? 'Team 1' : t2Total > t1Total ? 'Team 2' : 'Tied' }
}
